import React, {Component} from 'react'
import {connect} from 'react-redux'
import LoginActions from '../reducers/login/LoginRedux'
import '../assets/App.css'
import {
    Row,
    Col,
    Grid,
    Panel,
    Button,
    Navbar,
    PanelBody,
    PanelHeader,
    PanelContainer,
} from '@sketchpixy/rubix'
import {
    getFirstLineForAddress, getSecondLineForAddress, NOT_PROVIDED
} from "../utils/index";

class ConfirmPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            authenticate: !!props.loginToken,
        }
    }

    componentDidMount() {
        sessionStorage.getItem('signedPatientId') && sessionStorage.removeItem('signedPatientId');
        sessionStorage.getItem('signedDbqs') && sessionStorage.removeItem('signedDbqs');
        sessionStorage.getItem('currentDbq') && sessionStorage.removeItem('currentDbq');
        sessionStorage.getItem('patient') && sessionStorage.removeItem('patient');
        sessionStorage.getItem('doctorInfo') && sessionStorage.removeItem('doctorInfo');
        sessionStorage.getItem('startDate') && sessionStorage.removeItem('startDate');
        sessionStorage.getItem('aptDate') &&  sessionStorage.removeItem('aptDate');
        sessionStorage.getItem('correctedDbqRecords') && sessionStorage.removeItem('correctedDbqRecords');
        this.actions(`/admin/dashboard`)
    }

    componentWillReceiveProps(newProps) {
        if (newProps.loginToken) {
            this.setState({authenticate: true})
        }
    }

    goback = () => {
        if (this.props.loginToken) {
            this.props.logoutUser()
        }
        this.props.history.push('/login')
        
    }

    getAddress = (location) => {
        const address1 = getFirstLineForAddress(location)
        const address2 = getSecondLineForAddress(location);
        return (
            <div>
                {address1 && <div>
                    {address1}
                </div>}
                {address2 && <div>
                    {address2}
                </div>}
            </div>
        )

    }

    actions = link => {
        const {history} = this.props
        history.push(link)
    }

    render() {
        const { userInfo = {}} = this.props
        const {fullName, homeAddress, companyName, companyAddress, npi} = userInfo
        // localStorage.setItem("docName", fullName)
        // localStorage.setItem("docNpi", npi)
        return (
            <div id='auth-container' className='login'>
                <div id='auth-row-0'>
                    <div id='auth-cell'>
                        <Grid>
                            <Row>
                                <Col className="app-logo" md={10} sm={9} smOffset={0} xs={6} xsOffset={0} collapseLeft collapseRight>
                                    <a href="/" style={{paddingLeft: '15px'}}>
                                        <img style={{top: '-12px', margin: '0'}} src="/imgs/app/LogoSmall.svg" width="150"
                                            alt="" height="70"/>
                                    </a>
                                </Col>
                                <Col md={2} sm={3} smOffset={0} xs={6} xsOffset={0} collapseLeft collapseRight>
                                    <Navbar.Header {...this.props} style={{
                                        marginLeft: '0'
                                    }}>
                                        {/* <Navbar.Brand tabIndex='-1'>
                                            <span className="text-right fg-black">Contact your admin </span>
                                        </Navbar.Brand> */}
                                    </Navbar.Header>
                                    
                                </Col>
                            </Row>
                            <Row>
                                <Row className="mt-50 bg-custom-colot-blue loginFrom scale">
                                <Col smOffset={0} sm={12} md={12} xsOffset={0} collapseLeft collapseRight>
                                    <PanelContainer controls={false}>
                                        <Panel className="bg-custom-colot-blue">
                                            <PanelBody style={{padding: 0}}>
                                                <div className='text-center fg-black'>
                                                    <h1 className='heading-main' style={{margin: 15}}>Is The Information Correct?</h1>
                                                </div>
                                                <div>
                                                    <Row>
                                                        <Col smOffset={1} md={5} sm={5}>
                                                        <PanelContainer containerClasses="rubix-panel-container-with-bottom-shadow">
                                                            <Panel>
                                                            <PanelHeader className='bg-custome-red vbg-panel-header' style={{marginBottom: 0}}>
                                                                <Grid>
                                                                <Row>
                                                                    <Col md={12} className='fg-white'>
                
                                                                    </Col>
                                                                </Row>
                                                                </Grid>
                                                            </PanelHeader>
                                                            <PanelBody className="home-panel-body-user-request-height">
                                                                <Grid>
                                                                <div className="text-left">
                                                                    <h2 style={{marginTop: "13px", marginBottom: "0px"}}>
                                                                        <strong className="h2-size-tab">Medical Service Provider</strong>
                                                                    </h2>
                                                                    </div>
                                                                <div className='text-center fg-custome-blue'>
                                                                    <h2 className="h2-size-tab-name" style={{margin: 0, marginTop: 15, padding: 15, paddingBottom: 0, fontWeight: 'bold'}}>{companyName}</h2>
                                                                    <h4 style={{margin: 0, marginTop: 0, marginBottom: 69, padding: 15, fontWeight: 'bold'}}>
                                                                    <strong>
                                                                        {companyAddress ?
                                                                            this.getAddress(companyAddress)
                                                                            : NOT_PROVIDED}

                                                                    </strong>
                                                                    </h4>
                                                                </div>
                                                                </Grid>
                                                            </PanelBody>
                                                            </Panel>
                                                        </PanelContainer>
                                                        </Col>
                                                        <Col md={5} sm={5}>
                                                        <PanelContainer containerClasses="rubix-panel-container-with-bottom-shadow">
                                                            <Panel>
                                                            <PanelHeader className='bg-custome-red vbg-panel-header' style={{marginBottom: 0}}>
                                                                <Grid>
                                                                <Row>
                                                                    <Col md={12} className='fg-white'>
                                                                
                                                                    </Col>
                                                                </Row>
                                                                </Grid>
                                                            </PanelHeader>
                                                            <PanelBody className="home-panel-body-user-request-height">
                                                                <Grid>
                                                                    <div className="text-left">
                                                                    <h2 style={{marginTop: "13px", marginBottom: "0px"}}>
                                                                        <strong className="h2-size-tab">Doctor</strong>
                                                                    </h2>
                                                                    </div>
                                                                <div className='text-center fg-custome-blue '>
                                                                <h2 className="h2-size-tab-name" style={{margin: 0, marginTop: 15, padding: 15, paddingBottom: 0, fontWeight: 'bold'}}>{fullName}</h2>
                                                                    <h4 style={{margin: 0, marginTop: 0, marginBottom: 50, padding: 15, fontWeight: 'bold'}}>
                                                                    <strong>
                                                                        {homeAddress ?
                                                                            this.getAddress(homeAddress)
                                                                            : NOT_PROVIDED}
                                                                        <div>{npi ?
                                                                            'NPI: '+ npi
                                                                            : 'NPI: '}</div>
                                                                    </strong>
                                                                    </h4>
                                                                </div>
                                                                </Grid>
                                                            </PanelBody>
                                                            </Panel>
                                                        </PanelContainer>
                                                        </Col>
                                                    </Row>
                                                </div>
                                                <div>
                                                    <div style={{
                                                        padding: 25,
                                                        paddingTop: 0,
                                                        paddingBottom: 0,
                                                        margin: 'auto',
                                                        marginBottom: 25,
                                                        marginTop: 25
                                                    }}>
                                                         <Row style={{marginBottom: 15}}>
                                                            <Col xs={6} style={{paddingRight: '20px'}} collapseLeft collapseRight className='text-right'>
                                                                <Button
                                                                    lg
                                                                    type='button'
                                                                    bsStyle='primary'
                                                                    className="bg-custome-blue btn-padding"
                                                                    onClick={this.goback}
                                                                >No</Button>
                                                            </Col>
                                                            <Col xs={6} style={{paddingLeft: '20px'}} collapseLeft collapseRight
                                                                    className='text-left'>
                                                                <Button
                                                                    lg
                                                                    type='button'
                                                                    bsStyle='primary'
                                                                    className="bg-custome-blue btn-padding"
                                                                    onClick={this.actions.bind(this, `/admin/dashboard`)}
                                                                >Yes</Button>
                                                            </Col>
                                                        </Row>
                                                        <Row style={{marginBottom: 15}}>
                                                            <Col md={12} collapseLeft collapseRight
                                                                    className='fg-black text-center font-weight-600'>
                                                                <span className='disclamer'>By clicking YES, you are agree to our Terms & Conditions</span>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </div>
                                            </PanelBody>
                                        </Panel>
                                    </PanelContainer>
                                </Col>
                                </Row>
                            </Row>
                            <Row className="text-bottom">
                                <Col collapseLeft collapseRight>
                                    <span className="">&copy; 2023 Veteran Benefits Guide</span>
                                </Col>
                            </Row>
                        </Grid>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = ({login, user}) => {
        const {me: {userInfo = {}}} = user
        const {loginToken} = login
        return {loginToken, userInfo}
    }

const
    mapDispatchToProps = dispatch => ({
        logoutUser: () => {
            dispatch(LoginActions.createLogoutSuccess())
        }
    })

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmPage)
